import { Box, Button, Dialog, Slide, Typography, IconButton, Alert } from "../utils/mui-imports";
import React from "react";
import { FaChevronRight, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Toastbox = ({
  open = true,
  status,
  credits,
  isUser,
  customMessage = null,
  canClose = false,
  onClose = null,
  guestId = null,
  redirectURL = null,
}) => {
  const navigate = useNavigate();

  // Determine the message to display based on logic.
  let message = customMessage;
  let buttonText = "";
  let buttonAction = null;
  let title = null;
  if (!customMessage) {
    if (!isUser && credits > 0) {
      title = null;
      message = "Sign up now and get 3 extra free credits!";
      buttonText = "Sign Up for Free";
      buttonAction = () => navigate("/signup");
    } else if (!isUser && credits === 0) { 
      // SCENARIO #1: Guest runs out of credit
      title = "Out of Guest Credits";
      message = "Create more looks by signing up — it’s free!";
      buttonText = "Sign Up";
      buttonAction = () =>
        navigate("/signup", {
          state: { guest_id: guestId, redirect_url: redirectURL },
        });
    } else if (isUser && credits > 0) {
      title = "Want More Credits?";
      message = "Sign up with Facebook and get extra credits!";
      buttonText = "Connect Facebook";
      buttonAction = () => console.log("FB Auth Flow");
    } else if (isUser && credits === 0) {
      // SCENARIO #2: Signed Up User runs out of credits.
      // This is where the Out of Credits should trigger an email.
      // But there is no userid and email available yet.
      // This is also front-end; so we need to call an API
      title = "Out of Credits";
      message = "Refer friends or get Looks Saved.";
      buttonText = "Earn Credits";
      buttonAction = () => navigate("/profile");
    }
  }

  // Transition can be enabled as before (currently not used).
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
  });

  return (
    <Dialog
      open={open}
      onClose={canClose ? onClose : undefined}
      TransitionComponent={Transition}
      fullScreen
      slotProps={{
        paper: {
          sx: {
            // Matching aesthetics from Component 2 (increased opacity)
            backgroundColor: "none",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          },
        },
        backdrop: {
          sx: {
            // marginY: "10vh",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(255, 255, 255, 0.3)",
          },
        },
      }}
      sx={{
        zIndex: 10,
        // marginY: "10vh",
      }}
    >
      <Box height="100%" display="flex" alignItems="center" justifyContent="center">
        <Alert
         variant='contained'
          severity="error"
          icon={false}
          sx={{
            m: 1,
            borderRadius: 4,
            width: "100%",
            justifyContent:'center',
            alignContent:'center',
            justifyItems:'center',
            alignItems:'center'
          }}
        >
          {/* Close button area */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              width: "100%",
              pb:2
            }}
          >
            {canClose && (
              <a sx={{ p: 0, m: 0 }} aria-label="close" onClick={onClose}>
                <FaTimes size={25} />
              </a>
            )}
          </Box>

          {/* Title (if provided) */}
          {title && (
            <Typography color="black" variant="h3" fontWeight="bold" align="center">
              {title}
            </Typography>
          )}

          {/* Main message */}
          <Typography color="black" variant="body1" align="center">
            {message}
          </Typography>

          {/* Optional credits info */}
          {credits !== undefined && !customMessage && (
            <Typography color="black" align="center">
              Credits Available: <strong>{credits}</strong>
            </Typography>
          )}

          {/* Button container */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              flexWrap:'wrap',
              p: 2,
              gap: 2,
            }}
          >
            {buttonText && buttonAction && (
              <Button
                color="primary"
                endIcon={<FaChevronRight color="white" size={16} />}
                sx={{
                  backdropFilter: "blur(5px)",
                  backgroundColor: "rgba(1,1,1,0.85)",
                  borderRadius: 4,
                }}
                onClick={buttonAction}
                variant="contained"
              >
                <Typography textTransform="capitalize" fontWeight="bold" variant="h6" color="white">
                  {buttonText}
                </Typography>
              </Button>
            )}

            {/* Second button: Browse Looks */}
            <Button
              variant="outlined"
              onClick={() => navigate("/browse")}
            >
              <Typography textTransform="capitalize" fontWeight="bold" variant="h6">
                Browse Looks
              </Typography>
            </Button>
          </Box>
        </Alert>
      </Box>
    </Dialog>
  );
};

export default Toastbox;
